// const config = {
//   VUE_APP_MOBILE_OAUTH_REDIRECT_URL: 'https://grandpicnic.dev.npu.np.work',
//   // VUE_APP_MOBILE_OAUTH_REDIRECT_URL: 'https://localhost:8080',
//   VUE_APP_MOBILE_OAUTH_CONFIG_URL: 'https://hydra.dev.npu.np.work',
//   VUE_APP_MOBILE_OAUTH_CLIENT_ID: 'picnic-voting.dev.np.work',
//   VUE_APP_MOBILE_OAUTH_SCOPES: 'openid offline force-consent',
//   client_secret: 'df45ac32-5ddb-78cc-12c4-0429c731a9821',
//   api_path: 'https://my1.dev.npu.np.work/data/get/container/JSON',
// };
const config = {
  VUE_APP_MOBILE_OAUTH_REDIRECT_URL: 'https://grandpicnic.npu.np.work',
  VUE_APP_MOBILE_OAUTH_CONFIG_URL: 'https://auth.npu.np.work',
  VUE_APP_MOBILE_OAUTH_CLIENT_ID: 'grandpicnic.npu.np.work',
  VUE_APP_MOBILE_OAUTH_SCOPES: 'openid offline force-consent',
  client_secret: '3oniow0unDKWwwxAGgQ3fFHKMnEk',
  api_path: 'https://api.novaposhta.ua/v2.0/json'
};
export default config;
